
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import PartsDesigner from "../common/parts/PartsDesigner.vue";
import PartsLayout from "../common/parts/PartsLayout.vue";
import { Parts, LayoutConfig, Part, PartContext } from "../common/parts/types";
import PageDesignerControl from "./DesignerControl.vue";
import DesignPreviewModal from "../modals/design-preview-modal/DesignPreviewModal.vue";

@Component({
    name: "template-designer",
    components: { PageDesignerControl, PartsDesigner, PartsLayout, DesignPreviewModal },
})
export default class Designer extends Vue {
    @Prop({ type: Object }) template!: webpartv3.WebpartTemplate;
    @Prop({ type: Array }) parts!: Parts;
    /**
     * 웹파트 템플릿 개인화를 위한 환경인지 여부
     * 개인화인 경우 일부 관리적 기능이 제한됨
     */
    @Prop({ type: Boolean, default: false }) personal!: boolean;

    idCounter: number = 10;

    get layout(): LayoutConfig {
        var rt = {} as LayoutConfig;
        if (this.template) {
            const { cols, rows, rowHeight, designWidth } = this.template;
            rt = {
                cols,
                rows,
                rowHeight,
                designWidth,
                personal: this.personal,
            };
        }
        return rt;
    }

    /**
     * 편집 모드인지 보기 모드인지 설정
     */
    editMode: boolean = true;
    // parts: Parts = initailParts.map((x) => ({ ...x, id: x.data.id }))

    /**
     * Column 개수를 설정합니다.
     */
    setCols(v: number) {
        const designerParts: PartsDesigner = this.$refs.designerParts as any;
        if (v >= designerParts.minColumns() && v <= 15) this.template.cols = v;
    }

    /**
     * Row 개수를 설정합니다.
     */
    setRows(v: number) {
        const designerParts: PartsDesigner = this.$refs.designerParts as any;
        if (v >= designerParts.minRows() && v <= 15) this.template.rows = v;
    }

    handlePreview() {
        const modal: appbase.IModalOpenable = this.$refs["modal"] as any;
        const options: appbase.TModalInfo<any> = {
            component: DesignPreviewModal,
            props: {
                layout: this.layout,
                parts: this.parts.filter((x) => !x.available),
            },
        };
        modal.openModal(options);
    }
}
